import { IconChecklist } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useCases } from '../context/client-context'
import { useTranslation } from 'react-i18next'
import { BuildReportButton } from './build-report-button'

export function CasesPrimaryButtons() {
  const { setOpen } = useCases()
  const i18n = useTranslation()
  return (
    <div className='flex gap-2'>
      <Button className='space-x-1' onClick={() => setOpen('add')}>
        <span>{i18n.t('add_case')}</span> <IconChecklist size={18} />
      </Button>
      <BuildReportButton />
    </div>
  )
}
